// ABOUTME: Wraps one row of a reorderable list so it can be dragged, without moving its markup
// ABOUTME: A render prop, because a hook cannot be called inside a .map over rows

import type { ReactNode } from "react"
import { useSortableRow, type SortableRow } from "@shared/hooks/useSortableList"

interface CSortableRowProps {
  /** Which list the row belongs to; rows sharing one can be dragged between. */
  listId: string
  index: number
  /** Which container inside the list, when the list spans several. */
  group?: string | number
  isDisabled?: boolean
  children: (row: SortableRow) => ReactNode
}

export const CSortableRow = ({ listId, index, group, isDisabled = false, children }: CSortableRowProps) => {
  const row = useSortableRow(listId, index, isDisabled, group)

  return <>{children(row)}</>
}
